/**
 * Theme token helpers for script-drawn graphics (SVG attributes, SMIL, canvas)
 * that cannot reference CSS variables directly. Values live in
 * src/styles/cid/palette*.css; scripts read them and redraw on theme change.
 */

/** Current value of a CSS custom property (e.g. `--cid-flow-gold`). */
export function readToken(name: string, element: Element = document.documentElement): string {
  return getComputedStyle(element).getPropertyValue(name).trim();
}

/** Calls `callback` whenever the html theme class changes; returns the unsubscribe. */
export function observeThemeChange(callback: () => void): () => void {
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
}
